/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SetDateOfBirthResponse
 */
export interface SetDateOfBirthResponse {
    /**
     * Always true on success. Mirrors the field on the user profile so a client can settle its local state without a second fetch.
     * @type {boolean}
     * @memberof SetDateOfBirthResponse
     */
    hasDateOfBirth: boolean;
}

/**
 * Check if a given object implements the SetDateOfBirthResponse interface.
 */
export function instanceOfSetDateOfBirthResponse(value: object): value is SetDateOfBirthResponse {
    if (!('hasDateOfBirth' in value) || value['hasDateOfBirth'] === undefined) return false;
    return true;
}

export function SetDateOfBirthResponseFromJSON(json: any): SetDateOfBirthResponse {
    return SetDateOfBirthResponseFromJSONTyped(json, false);
}

export function SetDateOfBirthResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetDateOfBirthResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'hasDateOfBirth': json['hasDateOfBirth'],
    };
}

export function SetDateOfBirthResponseToJSON(json: any): SetDateOfBirthResponse {
    return SetDateOfBirthResponseToJSONTyped(json, false);
}

export function SetDateOfBirthResponseToJSONTyped(value?: SetDateOfBirthResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hasDateOfBirth': value['hasDateOfBirth'],
    };
}

